import { render, staticRenderFns } from "./Preset.vue?vue&type=template&id=30b96e78&scoped=true&lang=pug&"
import script from "./Preset.vue?vue&type=script&lang=ts&"
export * from "./Preset.vue?vue&type=script&lang=ts&"
import style0 from "./Preset.vue?vue&type=style&index=0&id=30b96e78&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b96e78",
  null
  
)

component.options.__file = "Preset.vue"
export default component.exports